// src/components/home/BannerSection.jsx
import React from 'react';
import video from '../../assets/video3.mp4';

const BannerSection = () => {
  return (
    <div className="program-card bg-[#EBE0CF] p-8 rounded-xl shadow-md relative transition-shadow duration-300 w-full max-w-[3000px] mx-auto hover:shadow-lg">
            <section id="banner" className="w-full h-[500px] md:h-[600px] lg:h-[900px] font-playfair relative">
              <div className="absolute inset-0 flex flex-col items-center justify-start py-12 z-20 pointer-events-none">
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0B2A2C] text-center relative pointer-events-auto">
                  Here is a visual of our promising hospitality at your service
                </h1>
              </div>
              {/* Bottom-Right Video */}
    <div
  className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2
             flex items-center justify-center
             w-[90%] sm:w-[85%] md:w-[90%] lg:w-[85%]
             h-[40%] sm:h-[50%] md:h-[40%] lg:h-[65%] z-10 mt-10"
>
  <video
    autoPlay
    muted
    loop
    playsInline
    className="w-full h-full object-cover rounded-[30px] shadow-lg"
  >
    <source src={video} type="video/mp4" />
    Your browser does not support the video tag.
  </video>
</div>

            </section>
            </div>
  );
};

export default BannerSection;